<template lang="pug">
  include ../../configs/templatesPUG/template.pug
  UiModal(
    v-model="isOpenModel"
    :title="$t('modal.enterLogPas')"
    :actions="actions"
    @close="reset"
  )
    form.add-account(@submit.prevent="addAccount")
      p.add-account__error(v-if="errorMessage") {{ errorMessage }}
      .add-account__field
        label {{ $t('modal.login') }}
        v-text-field(
          v-model="modalForm.login"
          @input="$v.modalForm.login.$touch"
          :error-messages="$valid.validation($v.modalForm.login, ['required', 'numeric'], '')"
          placeholder="01714"
          solo
          flat
        )
      .add-account__field
        label {{ $t('modal.password') }}
        v-text-field(
          v-model="modalForm.password"
          @input="$v.modalForm.password.$touch"
          :error-messages="$valid.validation($v.modalForm.password, ['required'], '')"
          placeholder="093456"
          flat
          solo
        )
</template>

<script>
import { mapActions } from 'vuex'
import { formLogin } from '@/configs/validationRules'

export default {
  name: 'AddAccount',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    errorMessage: '',
    isLoading: false,
    modalForm: {
      login: '',
      password: ''
    }
  }),
  computed: {
    isOpenModel: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    actions() {
      return [
        { text: this.$t('toCancel'), color: '#242D3B', disabled: this.isLoading },
        {
          text: this.$t('add'),
          color: '#FF5000',
          closeOnClick: false,
          loading: this.isLoading,
          handler: this.addAccount
        }
      ]
    }
  },
  validations: {
    modalForm: formLogin
  },
  watch: {
    modalForm: {
      handler() {
        if (this.errorMessage) this.errorMessage = ''
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getUserListAccount', 'postAddAccount']),
    async addAccount() {
      this.$v.$touch()
      if (this.$v.modalForm.$invalid) return

      this.isLoading = true
      // The active account no longer switches on add — just refresh the accounts list.
      const response = await this.postAddAccount({ body: { ...this.modalForm } })

      switch (response?.code) {
        case 200:
        case 201:
          await this.getUserListAccount()
          this.$emit('input', false)
          break
        case 400:
          this.errorMessage = this.$t('modal.invalidLoginPassword')
          break
        default:
          this.errorMessage = this.$t('modal.error')
      }
      this.isLoading = false
    },
    reset() {
      this.modalForm.login = ''
      this.modalForm.password = ''
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
.add-account
  position: relative
  display: flex
  flex-direction: column
  gap: 16px

  &__error
    margin: 0
    color: #FF5000
    font-size: 14px

  &__field
    label
      display: block
      margin-bottom: 4px
      color: #6F7684
      font-size: 14px
      font-weight: 500
</style>
